import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const AddUserSchema = z.object({
  email: z.string().email(),
  first_name: z.string(),
  last_name: z.string(),
  position: z.string(),
  admin: z.enum(['0', '1']),
  tfa_enable: z.enum(['1', '0']),
  licences: z.array(
    z.object({
      id: z.string(),
      tier_id: z.string(),
      has_access: z.boolean(),
    }),
  ),
});

export type AddUserForm = z.infer<typeof AddUserSchema>;

export const AddUserDefaultValues: AddUserForm = {
  email: '',
  first_name: '',
  last_name: '',
  position: '',
  admin: '0',
  tfa_enable: '1',
  licences: [],
};

export const useAddUserForm = () => {
  const form = useForm<AddUserForm>({
    defaultValues: AddUserDefaultValues,
    resolver: zodResolver(AddUserSchema),
    reValidateMode: 'onBlur',
    disabled: false,
  });

  return form;
};
